import type { CastImage } from "@/types/aggregate-items";

type CastImageSize = "100" | "300" | "640" | "800" | "1600";
type CastImageWidth = "300" | "400" | "500" | "1600";
type CastImageExt = ".webp" | ".jpg" | ".png";
type CastImageQuality = "q-40" | "q-60" | "q-80" | "q-90";

type ImageUrlOptions = {
  imageSize?: CastImageSize;
  imageWidth?: CastImageWidth;
  quality?: CastImageQuality;
  ext?: CastImageExt;
};

type ImageUrlFunction = (image: CastImage, options?: ImageUrlOptions) => string;

type ImageUrlFromGuidFunction = (
  imageUrl: string,
  options?: ImageUrlOptions,
) => string;

export const imageUrl: ImageUrlFunction = (
  image: CastImage,
  options: ImageUrlOptions = {},
): string => {
  const { imageSize = "300", imageWidth, quality, ext = ".webp" } = options;
  const url = new URL(image.url);
  const origin = url.origin;
  const sizePrefix = imageWidth ? `s-w${imageWidth}` : `s-l${imageSize}`;
  const qualitySuffix = quality ? `/${quality}` : "";
  const filename = `${sizePrefix}${qualitySuffix}${ext}`;
  return `${origin}/images/g/${image.zoomGuid}/${filename}`;
};

// https://i.ebayimg.com/images/g/7~AAAOSw9~5fZQ8z/s-l1600.jpg
export const extractImageGuid = (url: string): string | null => {
  const regex = /\/[zg]\/([A-Za-z0-9~]+)(?=\/|$)/;
  const match = url.match(regex);
  return match ? match[1] : null;
};

export const imageUrlFromGuid: ImageUrlFromGuidFunction = (
  imageUrl: string,
  options: ImageUrlOptions = {},
): string => {
  const guid = extractImageGuid(imageUrl);
  if (!guid) {
    return imageUrl; // Return original URL if GUID extraction fails
  }
  const { imageSize = "300", imageWidth, quality, ext = ".webp" } = options;
  const url = new URL(imageUrl);
  const origin = url.origin;
  const sizePrefix = imageWidth ? `s-w${imageWidth}` : `s-l${imageSize}`;
  const qualitySuffix = quality ? `/${quality}` : "";
  const filename = `${sizePrefix}${qualitySuffix}${ext}`;
  return `${origin}/images/g/${guid}/${filename}`;
};
